import { createContext } from 'react';

/**
 * Schema-form field IDs that must be rendered as *locked* in the schema
 * editor: no edit/delete controls, but still draggable (re-orderable).
 *
 * Provided per-block — currently only by the event-registration form's
 * `EditSchemaForm` (issue #1662). Defaults to an empty list so that for every
 * other form / content-type schema editor the shadowed `FormFieldWrapper`
 * stays a no-op.
 */
export const LockedSchemaFieldsContext = createContext<string[]>([]);
